// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3jnmZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOverlayPosition", function() {
    return 0, _useOverlayPosition.useOverlayPosition;
});
parcelHelpers.export(exports, "useOverlay", function() {
    return 0, _useOverlay.useOverlay;
});
parcelHelpers.export(exports, "useOverlayTrigger", function() {
    return 0, _useOverlayTrigger.useOverlayTrigger;
});
parcelHelpers.export(exports, "usePreventScroll", function() {
    return 0, _usePreventScroll.usePreventScroll;
});
parcelHelpers.export(exports, "ModalProvider", function() {
    return 0, _useModal.ModalProvider;
});
parcelHelpers.export(exports, "useModalProvider", function() {
    return 0, _useModal.useModalProvider;
});
parcelHelpers.export(exports, "OverlayProvider", function() {
    return 0, _useModal.OverlayProvider;
});
parcelHelpers.export(exports, "OverlayContainer", function() {
    return 0, _useModal.OverlayContainer;
});
parcelHelpers.export(exports, "useModal", function() {
    return 0, _useModal.useModal;
});
parcelHelpers.export(exports, "DismissButton", function() {
    return 0, _dismissButton.DismissButton;
});
parcelHelpers.export(exports, "ariaHideOutside", function() {
    return 0, _ariaHideOutside.ariaHideOutside;
});
parcelHelpers.export(exports, "usePopover", function() {
    return 0, _usePopover.usePopover;
});
parcelHelpers.export(exports, "useModalOverlay", function() {
    return 0, _useModalOverlay.useModalOverlay;
});
parcelHelpers.export(exports, "Overlay", function() {
    return 0, _overlay.Overlay;
});
parcelHelpers.export(exports, "useOverlayFocusContain", function() {
    return 0, _overlay.useOverlayFocusContain;
});
parcelHelpers.export(exports, "UNSTABLE_PortalProvider", function() {
    return 0, _portalProvider.UNSTABLE_PortalProvider;
});
parcelHelpers.export(exports, "useUNSTABLE_PortalContext", function() {
    return 0, _portalProvider.useUNSTABLE_PortalContext;
});
var _useOverlayPosition = require("./useOverlayPosition");
var _useOverlay = require("./useOverlay");
var _useOverlayTrigger = require("./useOverlayTrigger");
var _usePreventScroll = require("./usePreventScroll");
var _useModal = require("./useModal");
var _dismissButton = require("./DismissButton");
var _ariaHideOutside = require("./ariaHideOutside");
var _usePopover = require("./usePopover");
var _useModalOverlay = require("./useModalOverlay");
var _overlay = require("./Overlay");
var _portalProvider = require("./PortalProvider");

},{"./useOverlayPosition":"4xu1n","./useOverlay":"cr1BG","./useOverlayTrigger":"ixIYe","./usePreventScroll":"8XaQl","./useModal":"lWCul","./DismissButton":"5OOob","./ariaHideOutside":"jju83","./usePopover":"gnrPr","./useModalOverlay":"j5s3K","./Overlay":"gnwis","./PortalProvider":"1NiBy","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"4xu1n":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles positioning overlays like popovers and menus relative to a trigger
 * element, and updating the position when the window resizes.
 */ parcelHelpers.export(exports, "useOverlayPosition", function() {
    return useOverlayPosition;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _calculatePosition = require("./calculatePosition");
var _react = require("react");
var _useCloseOnScroll = require("./useCloseOnScroll");
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
// @ts-ignore
var visualViewport = typeof document !== 'undefined' && window.visualViewport;
function useOverlayPosition(props) {
    var direction = (0, _i18N.useLocale)().direction;
    var _props_arrowSize = props.arrowSize, arrowSize = _props_arrowSize === void 0 ? 0 : _props_arrowSize, targetRef = props.targetRef, overlayRef = props.overlayRef, _props_scrollRef = props.scrollRef, scrollRef = _props_scrollRef === void 0 ? overlayRef : _props_scrollRef, _props_placement = props.placement, placement = _props_placement === void 0 ? 'bottom' : _props_placement, _props_containerPadding = props.containerPadding, containerPadding = _props_containerPadding === void 0 ? 12 : _props_containerPadding, _props_shouldFlip = props.shouldFlip, shouldFlip = _props_shouldFlip === void 0 ? true : _props_shouldFlip, _props_boundaryElement = props.boundaryElement, boundaryElement = _props_boundaryElement === void 0 ? typeof document !== 'undefined' ? document.body : null : _props_boundaryElement, _props_offset = props.offset, offset = _props_offset === void 0 ? 0 : _props_offset, _props_crossOffset = props.crossOffset, crossOffset = _props_crossOffset === void 0 ? 0 : _props_crossOffset, _props_shouldUpdatePosition = props.shouldUpdatePosition, shouldUpdatePosition = _props_shouldUpdatePosition === void 0 ? true : _props_shouldUpdatePosition, _props_isOpen = props.isOpen, isOpen = _props_isOpen === void 0 ? true : _props_isOpen, onClose = props.onClose, maxHeight = props.maxHeight, _props_arrowBoundaryOffset = props.arrowBoundaryOffset, arrowBoundaryOffset = _props_arrowBoundaryOffset === void 0 ? 0 : _props_arrowBoundaryOffset;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        position: {},
        arrowOffsetLeft: undefined,
        arrowOffsetTop: undefined,
        maxHeight: undefined,
        placement: undefined
    }), 2), position = _useState[0], setPosition = _useState[1];
    var deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    var lastScale = (0, _react.useRef)(visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale);
    (0, _react.useEffect)(function() {
        if (isOpen) lastScale.current = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale;
    }, [
        isOpen
    ]);
    var updatePosition = (0, _react.useCallback)(function() {
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
        if ((visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        var anchor = null;
        if (scrollRef.current.contains(document.activeElement)) {
            var anchorRect = document.activeElement.getBoundingClientRect();
            var scrollRect = scrollRef.current.getBoundingClientRect();
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: anchorRect.top - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                anchor.offset = anchorRect.bottom - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        var overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            var _window_visualViewport;
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            var _window_visualViewport_height;
            overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + 'px';
        }
        var position = (0, _calculatePosition.calculatePosition)({
            placement: translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach(function(key) {
            return overlay.style[key] = position.position[key] + 'px';
        });
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : undefined;
        // Restore scroll position relative to anchor element.
        if (anchor) {
            var anchorRect1 = document.activeElement.getBoundingClientRect();
            var scrollRect1 = scrollRef.current.getBoundingClientRect();
            var newOffset = anchorRect1[anchor.type] - scrollRect1[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // Update position when anything changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _utils.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    useResize(updatePosition);
    // Update position when the overlay changes size (might need to flip).
    (0, _utils.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    // Update position when the target changes size (might need to flip).
    (0, _utils.useResizeObserver)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    var isResizing = (0, _react.useRef)(false);
    (0, _utils.useLayoutEffect)(function() {
        var timeout;
        var onResize = function() {
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        var onScroll = function() {
            if (isResizing.current) onResize();
        };
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener('resize', onResize);
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener('scroll', onScroll);
        return function() {
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener('resize', onResize);
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener('scroll', onScroll);
        };
    }, [
        updatePosition
    ]);
    var close = (0, _react.useCallback)(function() {
        if (!isResizing.current) onClose();
    }, [
        onClose,
        isResizing
    ]);
    // When scrolling a parent scrollable region of the trigger (other than the body),
    // we hide the popover. Otherwise, its position would be incorrect.
    (0, _useCloseOnScroll.useCloseOnScroll)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    var _position_maxHeight;
    return {
        overlayProps: {
            style: (0, _objectSpreadProps._)((0, _objectSpread._)({
                position: 'absolute',
                zIndex: 100000
            }, position.position), {
                maxHeight: (_position_maxHeight = position.maxHeight) !== null && _position_maxHeight !== void 0 ? _position_maxHeight : '100vh'
            })
        },
        placement: position.placement,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position.arrowOffsetLeft,
                top: position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function useResize(onResize) {
    (0, _utils.useLayoutEffect)(function() {
        window.addEventListener('resize', onResize, false);
        return function() {
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_sliced_to_array":"jzEiA","./calculatePosition":"jMmoz","react":"lbBKc","./useCloseOnScroll":"cg3b3","@react-aria/utils":"g2eof","@react-aria/i18n":"3B1HT","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"jMmoz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculatePositionInternal", function() {
    return calculatePositionInternal;
});
/**
 * Determines where to place the overlay with regards to the target and the position of an optional indicator.
 */ parcelHelpers.export(exports, "calculatePosition", function() {
    return calculatePosition;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@react-aria/utils");
var AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
var FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
var AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
var TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
var PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
var visualViewport = typeof document !== 'undefined' && window.visualViewport;
function getContainerDimensions(containerNode) {
    var width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    var scroll = {};
    var isPinchZoomedIn = (visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) > 1;
    if (containerNode.tagName === 'BODY') {
        var documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if (visualViewport) {
            top = visualViewport.offsetTop;
            left = visualViewport.offsetLeft;
        }
    } else {
        var ref;
        ref = getOffset(containerNode), width = ref.width, height = ref.height, top = ref.top, left = ref.left, ref;
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, _utils.isWebKit)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        top = visualViewport.pageTop;
        left = visualViewport.pageLeft;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function getDelta(axis, offset, size, // The dimensions of the boundary element that the popover is
// positioned within (most of the time this is the <body>).
boundaryDimensions, // The dimensions of the containing block element that the popover is
// positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    var containerScroll = containerDimensions.scroll[axis];
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    var boundarySize = boundaryDimensions[AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    var boundaryStartEdge = boundaryDimensions.scroll[AXIS[axis]] + padding;
    var boundaryEndEdge = boundarySize + boundaryDimensions.scroll[AXIS[axis]] - padding;
    var startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[AXIS[axis]];
    var endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function getMargins(node) {
    var style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function parsePlacement(input) {
    if (PARSED_PLACEMENT_CACHE[input]) return PARSED_PLACEMENT_CACHE[input];
    var _input_split = (0, _slicedToArray._)(input.split(' '), 2), placement = _input_split[0], crossPlacement = _input_split[1];
    var axis = AXIS[placement] || 'right';
    var crossAxis = CROSS_AXIS[axis];
    if (!AXIS[crossPlacement]) crossPlacement = 'center';
    var size = AXIS_SIZE[axis];
    var crossSize = AXIS_SIZE[crossAxis];
    PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return PARSED_PLACEMENT_CACHE[input];
}
function computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    var placement = placementInfo.placement, crossPlacement = placementInfo.crossPlacement, axis = placementInfo.axis, crossAxis = placementInfo.crossAxis, size = placementInfo.size, crossSize = placementInfo.crossSize;
    var position = {};
    // button position
    position[crossAxis] = childOffset[crossAxis];
    if (crossPlacement === 'center') //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
    else if (crossPlacement !== crossAxis) //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
     /* else {
    the overlay top should match the button top
  } */ 
    position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    var minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    var maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, _utils.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        var containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[TOTAL_SIZE[size]];
        position[FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    var containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[TOTAL_SIZE.height];
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    var overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
    var maxHeight = heightGrowthDirection !== 'top' ? // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
     - overlayTop // this is the top of the overlay
     - (margins.top + margins.bottom + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
    ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    var placement = placementInfo.placement, axis = placementInfo.axis, size = placementInfo.size;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[FLIPPED_DIRECTION[axis]] - padding);
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[FLIPPED_DIRECTION[axis]] - padding);
}
function calculatePositionInternal(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    var placementInfo = parsePlacement(placementInput);
    var size = placementInfo.size, crossAxis = placementInfo.crossAxis, crossSize = placementInfo.crossSize, placement = placementInfo.placement, crossPlacement = placementInfo.crossPlacement;
    var position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    var normalizedOffset = offset;
    var space = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        var flippedPlacementInfo = parsePlacement("".concat(FLIPPED_DIRECTION[placement], " ").concat(crossPlacement));
        var flippedPosition = computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        var flippedSpace = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    var heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    var delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    var maxHeight = getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    var arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    var preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - position[crossAxis];
    // Min/Max position limits for the arrow with respect to the overlay
    var arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    var arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    var arrowOverlappingChildMinEdge = childOffset[crossAxis] - position[crossAxis] + arrowSize / 2;
    var arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - position[crossAxis] - arrowSize / 2;
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    var arrowPositionOverlappingChild = (0, _utils.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, _utils.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function calculatePosition(opts) {
    var placement = opts.placement, targetNode = opts.targetNode, overlayNode = opts.overlayNode, scrollNode = opts.scrollNode, padding = opts.padding, shouldFlip = opts.shouldFlip, boundaryElement = opts.boundaryElement, offset = opts.offset, crossOffset = opts.crossOffset, maxHeight = opts.maxHeight, _opts_arrowSize = opts.arrowSize, arrowSize = _opts_arrowSize === void 0 ? 0 : _opts_arrowSize, _opts_arrowBoundaryOffset = opts.arrowBoundaryOffset, arrowBoundaryOffset = _opts_arrowBoundaryOffset === void 0 ? 0 : _opts_arrowBoundaryOffset;
    var container = overlayNode instanceof HTMLElement ? getContainingBlock(overlayNode) : document.documentElement;
    var isViewportContainer = container === document.documentElement;
    var containerPositionStyle = window.getComputedStyle(container).position;
    var isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    var childOffset = isViewportContainer ? getOffset(targetNode) : getPosition(targetNode, container);
    if (!isViewportContainer) {
        var _window_getComputedStyle = window.getComputedStyle(targetNode), marginTop = _window_getComputedStyle.marginTop, marginLeft = _window_getComputedStyle.marginLeft;
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    var overlaySize = getOffset(overlayNode);
    var margins = getMargins(overlayNode);
    overlaySize.width += margins.left + margins.right;
    overlaySize.height += margins.top + margins.bottom;
    var scrollSize = getScroll(scrollNode);
    var boundaryDimensions = getContainerDimensions(boundaryElement);
    var containerDimensions = getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    var containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? getOffset(container) : getPosition(container, boundaryElement);
    if (container.tagName === 'HTML' && boundaryElement.tagName === 'BODY') {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return calculatePositionInternal(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function getOffset(node) {
    var _node_getBoundingClientRect = node.getBoundingClientRect(), top = _node_getBoundingClientRect.top, left = _node_getBoundingClientRect.left, width = _node_getBoundingClientRect.width, height = _node_getBoundingClientRect.height;
    var _document_documentElement = document.documentElement, scrollTop = _document_documentElement.scrollTop, scrollLeft = _document_documentElement.scrollLeft, clientTop = _document_documentElement.clientTop, clientLeft = _document_documentElement.clientLeft;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function getPosition(node, parent) {
    var style = window.getComputedStyle(node);
    var offset;
    if (style.position === 'fixed') {
        var _node_getBoundingClientRect = node.getBoundingClientRect(), top = _node_getBoundingClientRect.top, left = _node_getBoundingClientRect.left, width = _node_getBoundingClientRect.width, height = _node_getBoundingClientRect.height;
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = getOffset(node);
        var parentOffset = getOffset(parent);
        var parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    var offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function isContainingBlock(node) {
    var style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || // @ts-ignore
    'backdropFilter' in style && style.backdropFilter !== 'none' || // @ts-ignore
    'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"cg3b3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onCloseMap", function() {
    return onCloseMap;
});
/** @private */ parcelHelpers.export(exports, "useCloseOnScroll", function() {
    return useCloseOnScroll;
});
var _react = require("react");
var onCloseMap = new WeakMap();
function useCloseOnScroll(opts) {
    var triggerRef = opts.triggerRef, isOpen = opts.isOpen, onClose = opts.onClose;
    (0, _react.useEffect)(function() {
        if (!isOpen || onClose === null) return;
        var onScroll = function(e) {
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            var target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
            var onCloseHandler = onClose || onCloseMap.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return function() {
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"cr1BG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior for overlays such as dialogs, popovers, and menus.
 * Hides the overlay when the user interacts outside it, when the Escape key is pressed,
 * or optionally, on blur. Only the top-most overlay will close at once.
 */ parcelHelpers.export(exports, "useOverlay", function() {
    return useOverlay;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var visibleOverlays = [];
function useOverlay(props, ref) {
    var onClose = props.onClose, shouldCloseOnBlur = props.shouldCloseOnBlur, isOpen = props.isOpen, _props_isDismissable = props.isDismissable, isDismissable = _props_isDismissable === void 0 ? false : _props_isDismissable, _props_isKeyboardDismissDisabled = props.isKeyboardDismissDisabled, isKeyboardDismissDisabled = _props_isKeyboardDismissDisabled === void 0 ? false : _props_isKeyboardDismissDisabled, shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside;
    // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
    (0, _react.useEffect)(function() {
        if (isOpen) visibleOverlays.push(ref);
        return function() {
            var index = visibleOverlays.indexOf(ref);
            if (index >= 0) visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    var onHide = function() {
        if (visibleOverlays[visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    var onInteractOutsideStart = function(e) {
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if (visibleOverlays[visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    var onInteractOutside = function(e) {
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if (visibleOverlays[visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    var onKeyDown = function(e) {
        if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    // Handle clicking outside the overlay to close it
    (0, _interactions.useInteractOutside)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
        onInteractOutsideStart: onInteractOutsideStart
    });
    var focusWithinProps = (0, _interactions.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: function(e) {
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, _focus.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
        }
    }).focusWithinProps;
    var onPointerDownUnderlay = function(e) {
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: (0, _objectSpread._)({
            onKeyDown: onKeyDown
        }, focusWithinProps),
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}

},{"@swc/helpers/_/_object_spread":"96NPP","@react-aria/focus":"d7X1E","react":"lbBKc","@react-aria/interactions":"1h5DV","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"ixIYe":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles the behavior and accessibility for an overlay trigger, e.g. a button
 * that opens a popover, menu, or other overlay that is positioned relative to the trigger.
 */ parcelHelpers.export(exports, "useOverlayTrigger", function() {
    return useOverlayTrigger;
});
var _useCloseOnScroll = require("./useCloseOnScroll");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useOverlayTrigger(props, state, ref) {
    var type = props.type;
    var isOpen = state.isOpen;
    // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
    // without forcing users to pass onClose.
    (0, _react.useEffect)(function() {
        if (ref && ref.current) (0, _useCloseOnScroll.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    var ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    var overlayId = (0, _utils.useId)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : null,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

},{"./useCloseOnScroll":"cg3b3","react":"lbBKc","@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"8XaQl":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prevents scrolling on the document body on mount, and
 * restores it on unmount. Also ensures that content does not
 * shift due to the scrollbars disappearing.
 */ parcelHelpers.export(exports, "usePreventScroll", function() {
    return usePreventScroll;
});
var _utils = require("@react-aria/utils");
// @ts-ignore
var visualViewport = typeof document !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
var nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
var preventScrollCount = 0;
var restore;
function usePreventScroll() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isDisabled = options.isDisabled;
    (0, _utils.useLayoutEffect)(function() {
        if (isDisabled) return;
        preventScrollCount++;
        if (preventScrollCount === 1) {
            if ((0, _utils.isIOS)()) restore = preventScrollMobileSafari();
            else restore = preventScrollStandard();
        }
        return function() {
            preventScrollCount--;
            if (preventScrollCount === 0) restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function preventScrollStandard() {
    return (0, _utils.chain)(setStyle(document.documentElement, 'paddingRight', "".concat(window.innerWidth - document.documentElement.clientWidth, "px")), setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function preventScrollMobileSafari() {
    var scrollable;
    var restoreScrollableStyles;
    var onTouchStart = function(e) {
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, _utils.getScrollParent)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === 'auto') restoreScrollableStyles = setStyle(scrollable, 'overscrollBehavior', 'contain');
    };
    var onTouchMove = function(e) {
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    var onTouchEnd = function(e) {
        var target = e.target;
        // Apply this change if we're not already focused on the target element
        if (willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(function() {
                target.style.transform = '';
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    var onFocus = function(e) {
        var target = e.target;
        if (willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(function() {
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if (visualViewport) {
                    if (visualViewport.height < window.innerHeight) // If the keyboard is already visible, do this after one additional frame
                    // to wait for the transform to be removed.
                    requestAnimationFrame(function() {
                        scrollIntoView(target);
                    });
                    else // Otherwise, wait for the visual viewport to resize before scrolling so we can
                    // measure the correct position to scroll to.
                    visualViewport.addEventListener('resize', function() {
                        return scrollIntoView(target);
                    }, {
                        once: true
                    });
                }
            });
        }
    };
    var restoreStyles = null;
    var setupStyles = function() {
        if (restoreStyles) return;
        var onWindowScroll = function() {
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        var scrollX = window.pageXOffset;
        var scrollY = window.pageYOffset;
        restoreStyles = (0, _utils.chain)(addEvent(window, 'scroll', onWindowScroll), setStyle(document.documentElement, 'paddingRight', "".concat(window.innerWidth - document.documentElement.clientWidth, "px")), setStyle(document.documentElement, 'overflow', 'hidden'), setStyle(document.body, 'marginTop', "-".concat(scrollY, "px")), function() {
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    var removeEvents = (0, _utils.chain)(addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), addEvent(document, 'focus', onFocus, true));
    return function() {
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 ? void 0 : restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 ? void 0 : restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function setStyle(element, style, value) {
    var cur = element.style[style];
    element.style[style] = value;
    return function() {
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function addEvent(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    return function() {
        target.removeEventListener(event, handler, options);
    };
}
function scrollIntoView(target) {
    var root = document.scrollingElement || document.documentElement;
    while(target && target !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        var scrollable = (0, _utils.getScrollParent)(target);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
            var scrollableTop = scrollable.getBoundingClientRect().top;
            var targetTop = target.getBoundingClientRect().top;
            if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        target = scrollable.parentElement;
    }
}
function willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

},{"@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"lWCul":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Each ModalProvider tracks how many modals are open in its subtree. On mount, the modals
 * trigger `addModal` to increment the count, and trigger `removeModal` on unmount to decrement it.
 * This is done recursively so that all parent providers are incremented and decremented.
 * If the modal count is greater than zero, we add `aria-hidden` to this provider to hide its
 * subtree from screen readers. This is done using React context in order to account for things
 * like portals, which can cause the React tree and the DOM tree to differ significantly in structure.
 */ parcelHelpers.export(exports, "ModalProvider", function() {
    return ModalProvider;
});
/**
 * Used to determine if the tree should be aria-hidden based on how many
 * modals are open.
 */ parcelHelpers.export(exports, "useModalProvider", function() {
    return useModalProvider;
});
/**
 * An OverlayProvider acts as a container for the top-level application.
 * Any application that uses modal dialogs or other overlays should
 * be wrapped in a `<OverlayProvider>`. This is used to ensure that
 * the main content of the application is hidden from screen readers
 * if a modal or other overlay is opened. Only the top-most modal or
 * overlay should be accessible at once.
 */ parcelHelpers.export(exports, "OverlayProvider", function() {
    return OverlayProvider;
});
/**
 * A container for overlays like modals and popovers. Renders the overlay
 * into a Portal which is placed at the end of the document body.
 * Also ensures that the overlay is hidden from screen readers if a
 * nested modal is opened. Only the top-most modal or overlay should
 * be accessible at once.
 */ parcelHelpers.export(exports, "OverlayContainer", function() {
    return OverlayContainer;
});
/**
 * Hides content outside the current `<OverlayContainer>` from screen readers
 * on mount and restores it on unmount. Typically used by modal dialogs and
 * other types of overlays to ensure that only the top-most modal is
 * accessible at once.
 */ parcelHelpers.export(exports, "useModal", function() {
    return useModal;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _ssr = require("@react-aria/ssr");
var Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function ModalProvider(props) {
    var children = props.children;
    var parent = (0, _react.useContext)(Context);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), modalCount = _useState[0], setModalCount = _useState[1];
    var context = (0, _react.useMemo)(function() {
        return {
            parent: parent,
            modalCount: modalCount,
            addModal: function() {
                setModalCount(function(count) {
                    return count + 1;
                });
                if (parent) parent.addModal();
            },
            removeModal: function() {
                setModalCount(function(count) {
                    return count - 1;
                });
                if (parent) parent.removeModal();
            }
        };
    }, [
        parent,
        modalCount
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: context
    }, children);
}
function useModalProvider() {
    var context = (0, _react.useContext)(Context);
    return {
        modalProviderProps: {
            'aria-hidden': context && context.modalCount > 0 ? true : null
        }
    };
}
/**
 * Creates a root node that will be aria-hidden if there are other modals open.
 */ function OverlayContainerDOM(props) {
    var modalProviderProps = useModalProvider().modalProviderProps;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _objectSpread._)({
        "data-overlay-container": true
    }, props, modalProviderProps));
}
function OverlayProvider(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalProvider, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayContainerDOM, props));
}
function OverlayContainer(props) {
    var isSSR = (0, _ssr.useIsSSR)();
    var _props_portalContainer = props.portalContainer, portalContainer = _props_portalContainer === void 0 ? isSSR ? null : document.body : _props_portalContainer, rest = (0, _objectWithoutProperties._)(props, [
        "portalContainer"
    ]);
    (0, _reactDefault.default).useEffect(function() {
        if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest('[data-overlay-container]')) throw new Error('An OverlayContainer must not be inside another container. Please change the portalContainer prop.');
    }, [
        portalContainer
    ]);
    if (!portalContainer) return null;
    var contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayProvider, rest);
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, portalContainer);
}
function useModal(options) {
    // Add aria-hidden to all parent providers on mount, and restore on unmount.
    var context = (0, _react.useContext)(Context);
    if (!context) throw new Error('Modal is not contained within a provider');
    (0, _react.useEffect)(function() {
        if ((options === null || options === void 0 ? void 0 : options.isDisabled) || !context || !context.parent) return;
        // The immediate context is from the provider containing this modal, so we only
        // want to trigger aria-hidden on its parents not on the modal provider itself.
        context.parent.addModal();
        return function() {
            if (context && context.parent) context.parent.removeModal();
        };
    }, [
        context,
        context.parent,
        options === null || options === void 0 ? void 0 : options.isDisabled
    ]);
    return {
        modalProps: {
            'data-ismodal': !(options === null || options === void 0 ? void 0 : options.isDisabled)
        }
    };
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_without_properties":"lgaS6","@swc/helpers/_/_sliced_to_array":"jzEiA","react":"lbBKc","react-dom":"jBsku","@react-aria/ssr":"jaCiN","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"5OOob":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A visually hidden button that can be used to allow screen reader
 * users to dismiss a modal or popup when there is no visual
 * affordance to do so.
 */ parcelHelpers.export(exports, "DismissButton", function() {
    return DismissButton;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function DismissButton(props) {
    var onDismiss = props.onDismiss, otherProps = (0, _objectWithoutProperties._)(props, [
        "onDismiss"
    ]);
    var stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/overlays');
    var labels = (0, _utils.useLabels)(otherProps, stringFormatter.format('dismiss'));
    var onClick = function() {
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _visuallyHidden.VisuallyHidden), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", (0, _objectSpreadProps._)((0, _objectSpread._)({}, labels), {
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    })));
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","../intl/*.json":"9nHDX","react":"lbBKc","@react-aria/utils":"g2eof","@react-aria/i18n":"3B1HT","@react-aria/visually-hidden":"glklC","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"9nHDX":[function(require,module,exports) {
var _temp0 = require("fb9cd8c40f374ea7");
var _temp1 = require("a70ef199009c6bc");
var _temp2 = require("6d7d9859bbd1508e");
var _temp3 = require("9398db2e1e63d3a1");
var _temp4 = require("727ec5cd6d2d771b");
var _temp5 = require("2b15efe2acc8174a");
var _temp6 = require("152ad9854112850");
var _temp7 = require("325a44e6fea34728");
var _temp8 = require("73f75de9ec78343e");
var _temp9 = require("7d9cc0075877d56c");
var _temp10 = require("d0bde47587c84622");
var _temp11 = require("900b9a4087671619");
var _temp12 = require("7250918f8c99555");
var _temp13 = require("326a7ea5266290");
var _temp14 = require("b14d92ef814f417d");
var _temp15 = require("a3011f7b477adc71");
var _temp16 = require("14e3c1cbf2e5f8ff");
var _temp17 = require("b12b8c0ce27bafc4");
var _temp18 = require("159c6d3b1ec26f78");
var _temp19 = require("57a1f441a85265a");
var _temp20 = require("186e5a0acab13def");
var _temp21 = require("9f729321b82985dc");
var _temp22 = require("86e8c1450c533db8");
var _temp23 = require("d9bf93fb169c4803");
var _temp24 = require("c3e2d6470a649594");
var _temp25 = require("d4fae2e90e6f3b2c");
var _temp26 = require("556e48fafccea7c");
var _temp27 = require("a55605310e2680f7");
var _temp28 = require("2374d5326777a1ce");
var _temp29 = require("eb36c86d33f7d601");
var _temp30 = require("9f997e85300917b2");
var _temp31 = require("763fae833506549b");
var _temp32 = require("fe36a04df3ebb49b");
var _temp33 = require("d89e8e3d5e2f2eb7");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fb9cd8c40f374ea7":"hzKR4","a70ef199009c6bc":"6Efk7","6d7d9859bbd1508e":"kL5ln","9398db2e1e63d3a1":"i52HF","727ec5cd6d2d771b":"hljl8","2b15efe2acc8174a":"2Qnde","152ad9854112850":"7yLfB","325a44e6fea34728":"cGON4","73f75de9ec78343e":"fkpkG","7d9cc0075877d56c":"3fZYF","d0bde47587c84622":"fCEpG","900b9a4087671619":"kF4DF","7250918f8c99555":"1O7Ti","326a7ea5266290":"6q4Ug","b14d92ef814f417d":"6kgfP","a3011f7b477adc71":"ggEgy","14e3c1cbf2e5f8ff":"hE5Z9","b12b8c0ce27bafc4":"3doNF","159c6d3b1ec26f78":"cZohH","57a1f441a85265a":"cz9Qe","186e5a0acab13def":"11KsG","9f729321b82985dc":"4KNII","86e8c1450c533db8":"bsYRp","d9bf93fb169c4803":"f39Ir","c3e2d6470a649594":"fDJ9R","d4fae2e90e6f3b2c":"eR4Vv","556e48fafccea7c":"icZsv","a55605310e2680f7":"arp4D","2374d5326777a1ce":"8Z6Hd","eb36c86d33f7d601":"fHZkR","9f997e85300917b2":"9UKKx","763fae833506549b":"13gRE","fe36a04df3ebb49b":"lmpd8","d89e8e3d5e2f2eb7":"lMcYc"}],"hzKR4":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u062A\u062C\u0627\u0647\u0644"
};

},{}],"6Efk7":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"
};

},{}],"kL5ln":[function(require,module,exports) {
module.exports = {
    "dismiss": "Odstranit"
};

},{}],"i52HF":[function(require,module,exports) {
module.exports = {
    "dismiss": "Luk"
};

},{}],"hljl8":[function(require,module,exports) {
module.exports = {
    "dismiss": "Schlie\xdfen"
};

},{}],"2Qnde":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"
};

},{}],"7yLfB":[function(require,module,exports) {
module.exports = {
    "dismiss": "Dismiss"
};

},{}],"cGON4":[function(require,module,exports) {
module.exports = {
    "dismiss": "Descartar"
};

},{}],"fkpkG":[function(require,module,exports) {
module.exports = {
    "dismiss": "L\xf5peta"
};

},{}],"3fZYF":[function(require,module,exports) {
module.exports = {
    "dismiss": "Hylk\xe4\xe4"
};

},{}],"fCEpG":[function(require,module,exports) {
module.exports = {
    "dismiss": "Rejeter"
};

},{}],"kF4DF":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u05D4\u05EA\u05E2\u05DC\u05DD"
};

},{}],"1O7Ti":[function(require,module,exports) {
module.exports = {
    "dismiss": "Odbaci"
};

},{}],"6q4Ug":[function(require,module,exports) {
module.exports = {
    "dismiss": "Elutas\xedt\xe1s"
};

},{}],"6kgfP":[function(require,module,exports) {
module.exports = {
    "dismiss": "Ignora"
};

},{}],"ggEgy":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u9589\u3058\u308B"
};

},{}],"hE5Z9":[function(require,module,exports) {
module.exports = {
    "dismiss": "\uBB34\uC2DC"
};

},{}],"3doNF":[function(require,module,exports) {
module.exports = {
    "dismiss": "Atmesti"
};

},{}],"cZohH":[function(require,module,exports) {
module.exports = {
    "dismiss": "Ner\u0101d\u012Bt"
};

},{}],"cz9Qe":[function(require,module,exports) {
module.exports = {
    "dismiss": "Lukk"
};

},{}],"11KsG":[function(require,module,exports) {
module.exports = {
    "dismiss": "Negeren"
};

},{}],"4KNII":[function(require,module,exports) {
module.exports = {
    "dismiss": "Zignoruj"
};

},{}],"bsYRp":[function(require,module,exports) {
module.exports = {
    "dismiss": "Descartar"
};

},{}],"f39Ir":[function(require,module,exports) {
module.exports = {
    "dismiss": "Dispensar"
};

},{}],"fDJ9R":[function(require,module,exports) {
module.exports = {
    "dismiss": "Revocare"
};

},{}],"eR4Vv":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"
};

},{}],"icZsv":[function(require,module,exports) {
module.exports = {
    "dismiss": "Zru\u0161i\u0165"
};

},{}],"arp4D":[function(require,module,exports) {
module.exports = {
    "dismiss": "Opusti"
};

},{}],"8Z6Hd":[function(require,module,exports) {
module.exports = {
    "dismiss": "Odbaci"
};

},{}],"fHZkR":[function(require,module,exports) {
module.exports = {
    "dismiss": "Avvisa"
};

},{}],"9UKKx":[function(require,module,exports) {
module.exports = {
    "dismiss": "Kapat"
};

},{}],"13gRE":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
};

},{}],"lmpd8":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u53D6\u6D88"
};

},{}],"lMcYc":[function(require,module,exports) {
module.exports = {
    "dismiss": "\u95DC\u9589"
};

},{}],"jju83":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hides all elements in the DOM outside the given targets from screen readers using aria-hidden,
 * and returns a function to revert these changes. In addition, changes to the DOM are watched
 * and new elements outside the targets are automatically hidden.
 * @param targets - The elements that should remain visible.
 * @param root - Nothing will be hidden above this element.
 * @returns - A function to restore all hidden elements.
 */ parcelHelpers.export(exports, "ariaHideOutside", function() {
    return ariaHideOutside;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var refCountMap = new WeakMap();
var observerStack = [];
function ariaHideOutside(targets) {
    var root = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.body;
    var visibleNodes = new Set(targets);
    var hiddenNodes = new Set();
    var walk = function(root) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Keep live announcer and top layer elements (e.g. toasts) visible.
            for(var _iterator = root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                visibleNodes.add(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var acceptNode = function(node) {
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Skip this node but continue to children if one of the targets is inside the node.
                for(var _iterator = visibleNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var target = _step.value;
                    if (node.contains(target)) return NodeFilter.FILTER_SKIP;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        var acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            var node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    var hide = function(node) {
        var _refCountMap_get;
        var refCount = (_refCountMap_get = refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
        if (refCount === 0) node.setAttribute('aria-hidden', 'true');
        hiddenNodes.add(node);
        refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if (observerStack.length) observerStack[observerStack.length - 1].disconnect();
    walk(root);
    var observer = new MutationObserver(function(changes) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var change = _step.value;
                if (change.type !== 'childList' || change.addedNodes.length === 0) return "continue";
                // If the parent element of the added nodes is not within one of the targets,
                // and not already inside a hidden node, hide all of the new children.
                if (!(0, _toConsumableArray._)(visibleNodes).concat((0, _toConsumableArray._)(hiddenNodes)).some(function(node) {
                    return node.contains(change.target);
                })) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = change.removedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var node = _step1.value;
                            if (node instanceof Element) {
                                visibleNodes.delete(node);
                                hiddenNodes.delete(node);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = change.addedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var node1 = _step2.value;
                            if ((node1 instanceof HTMLElement || node1 instanceof SVGElement) && (node1.dataset.liveAnnouncer === 'true' || node1.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(node1);
                            else if (node1 instanceof Element) walk(node1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            };
            for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    var observerWrapper = {
        observe: function() {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect: function() {
            observer.disconnect();
        }
    };
    observerStack.push(observerWrapper);
    return function() {
        observer.disconnect();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hiddenNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                var count = refCountMap.get(node);
                if (count === 1) {
                    node.removeAttribute('aria-hidden');
                    refCountMap.delete(node);
                } else refCountMap.set(node, count - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === observerStack[observerStack.length - 1]) {
            observerStack.pop();
            if (observerStack.length) observerStack[observerStack.length - 1].observe();
        } else observerStack.splice(observerStack.indexOf(observerWrapper), 1);
    };
}

},{"@swc/helpers/_/_to_consumable_array":"4Hwej","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"gnrPr":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a popover component.
 * A popover is an overlay element positioned relative to a trigger.
 */ parcelHelpers.export(exports, "usePopover", function() {
    return usePopover;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _ariaHideOutside = require("./ariaHideOutside");
var _useOverlayPosition = require("./useOverlayPosition");
var _utils = require("@react-aria/utils");
var _useOverlay = require("./useOverlay");
var _usePreventScroll = require("./usePreventScroll");
function usePopover(props, state) {
    var triggerRef = props.triggerRef, popoverRef = props.popoverRef, isNonModal = props.isNonModal, isKeyboardDismissDisabled = props.isKeyboardDismissDisabled, shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside, otherProps = (0, _objectWithoutProperties._)(props, [
        "triggerRef",
        "popoverRef",
        "isNonModal",
        "isKeyboardDismissDisabled",
        "shouldCloseOnInteractOutside"
    ]);
    var _useOverlay1 = (0, _useOverlay.useOverlay)({
        isOpen: state.isOpen,
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, popoverRef), overlayProps = _useOverlay1.overlayProps, underlayProps = _useOverlay1.underlayProps;
    var _useOverlayPosition1 = (0, _useOverlayPosition.useOverlayPosition)((0, _objectSpreadProps._)((0, _objectSpread._)({}, otherProps), {
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal ? state.close : null
    })), positionProps = _useOverlayPosition1.overlayProps, arrowProps = _useOverlayPosition1.arrowProps, placement = _useOverlayPosition1.placement;
    (0, _usePreventScroll.usePreventScroll)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, _utils.useLayoutEffect)(function() {
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, _ariaHideOutside.ariaHideOutside)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, _utils.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","./ariaHideOutside":"jju83","./useOverlayPosition":"4xu1n","@react-aria/utils":"g2eof","./useOverlay":"cr1BG","./usePreventScroll":"8XaQl","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"j5s3K":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a modal component.
 * A modal is an overlay element which blocks interaction with elements outside it.
 */ parcelHelpers.export(exports, "useModalOverlay", function() {
    return useModalOverlay;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _ariaHideOutside = require("./ariaHideOutside");
var _useOverlay = require("./useOverlay");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _overlay = require("./Overlay");
var _usePreventScroll = require("./usePreventScroll");
function useModalOverlay(props, state, ref) {
    var _useOverlay1 = (0, _useOverlay.useOverlay)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        isOpen: state.isOpen,
        onClose: state.close
    }), ref), overlayProps = _useOverlay1.overlayProps, underlayProps = _useOverlay1.underlayProps;
    (0, _usePreventScroll.usePreventScroll)({
        isDisabled: !state.isOpen
    });
    (0, _overlay.useOverlayFocusContain)();
    (0, _react.useEffect)(function() {
        if (state.isOpen) return (0, _ariaHideOutside.ariaHideOutside)([
            ref.current
        ]);
    }, [
        state.isOpen,
        ref
    ]);
    return {
        modalProps: (0, _utils.mergeProps)(overlayProps),
        underlayProps: underlayProps
    };
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","./ariaHideOutside":"jju83","./useOverlay":"cr1BG","@react-aria/utils":"g2eof","react":"lbBKc","./Overlay":"gnwis","./usePreventScroll":"8XaQl","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"gnwis":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlayContext", function() {
    return OverlayContext;
});
/**
 * A container which renders an overlay such as a popover or modal in a portal,
 * and provides a focus scope for the child elements.
 */ parcelHelpers.export(exports, "Overlay", function() {
    return Overlay;
});
/** @private */ parcelHelpers.export(exports, "useOverlayFocusContain", function() {
    return useOverlayFocusContain;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _interactions = require("@react-aria/interactions");
var _focus = require("@react-aria/focus");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _ssr = require("@react-aria/ssr");
var _utils = require("@react-aria/utils");
var _portalProvider = require("./PortalProvider");
var OverlayContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function Overlay(props) {
    var isSSR = (0, _ssr.useIsSSR)();
    var _props_portalContainer = props.portalContainer, portalContainer = _props_portalContainer === void 0 ? isSSR ? null : document.body : _props_portalContainer, isExiting = props.isExiting;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), contain = _useState[0], setContain = _useState[1];
    var contextValue = (0, _react.useMemo)(function() {
        return {
            contain: contain,
            setContain: setContain
        };
    }, [
        contain,
        setContain
    ]);
    var getContainer = (0, _portalProvider.useUNSTABLE_PortalContext)().getContainer;
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    var contents = props.children;
    if (!props.disableFocusManagement) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focus.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _interactions.ClearPressResponder), null, contents));
    return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(contents, portalContainer);
}
function useOverlayFocusContain() {
    var ctx = (0, _react.useContext)(OverlayContext);
    var setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, _utils.useLayoutEffect)(function() {
        setContain === null || setContain === void 0 ? void 0 : setContain(true);
    }, [
        setContain
    ]);
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","@react-aria/interactions":"1h5DV","@react-aria/focus":"d7X1E","react":"lbBKc","react-dom":"jBsku","@react-aria/ssr":"jaCiN","@react-aria/utils":"g2eof","./PortalProvider":"1NiBy","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"1NiBy":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalContext", function() {
    return PortalContext;
});
parcelHelpers.export(exports, "UNSTABLE_PortalProvider", function() {
    return UNSTABLE_PortalProvider;
});
parcelHelpers.export(exports, "useUNSTABLE_PortalContext", function() {
    return useUNSTABLE_PortalContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var PortalContext = /*#__PURE__*/ (0, _react.createContext)({});
function UNSTABLE_PortalProvider(props) {
    var getContainer = props.getContainer;
    var _useUNSTABLE_PortalContext = useUNSTABLE_PortalContext(), ctxGetContainer = _useUNSTABLE_PortalContext.getContainer;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PortalContext.Provider, {
        value: {
            getContainer: getContainer === null ? null : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function useUNSTABLE_PortalContext() {
    var _useContext;
    return (_useContext = (0, _react.useContext)(PortalContext)) !== null && _useContext !== void 0 ? _useContext : {};
}

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=useCalendar.stories.f4dc6ea6.js.map
